import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
import { Helmet } from "react-helmet";
import i18n from "../../../../i18n";
import BudgetMiddleware from "../../../../middleware/modules/accounting/budget";
import Budget from "../../../../components/modules/accounting/budget";
// middlewares

const mapStateToProps = ({ auth, budget }) => ({
  authUser:auth.authUser,
  isProcessing: budget.isProcessing,
  isError: budget.isError,
  errorMessage: budget.errorMessage,
  datalist: budget.data,
  helperBudget: budget.helperBudget,
  afterSave: budget.afterSave,
  showModal: budget.showModal
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      create: () => BudgetMiddleware.create(),
      getHelper: () => BudgetMiddleware.getHelper(),
      reset: () => BudgetMiddleware.resetList(),
      search: (data) => BudgetMiddleware.list(data),
      update: (data) => BudgetMiddleware.update(data),
      void: (data,search) => BudgetMiddleware.beforeVoid(data,search),
      delete: (id, search) => BudgetMiddleware.beforeDelete(id, search),
      submit: (data, search) => BudgetMiddleware.beforeSaveNew(data, search),
      approve: (id, value, search) => BudgetMiddleware.beforeApprove(id, value, search),
      reject: (id, value, search) => BudgetMiddleware.beforeReject(id, value, search),
    },
    dispatch
  );
};
class BudgetContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.object,
    search: PropTypes.func.isRequired,
    afterSave: PropTypes.bool,

  };

  static defaultProps = {
    afterSave: false,
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  };

  constructor(props) {
    super(props);
    this.submitItem = this.submitItem.bind(this);
    this.createItem = this.createItem.bind(this);
    this.voidItem = this.voidItem.bind(this);
    this.approveItem = this.approveItem.bind(this);
    this.rejectItem = this.rejectItem.bind(this);
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
    this.props.reset();
    this.props.search(search);
  }

  createItem() {
    this.props.getHelper();
    this.props.create();
  }

  submitItem() {
    this.props.submit();
  }

  approveItem(id, value, search) {
    this.props.approve(id, value, search);
  }
  rejectItem(id, value, search) {
    this.props.reject(id, value, search);
  }

  voidItem(data,search) {
    this.props.delete(data,search);
  }

  render() {
    const { isProcessing, search, datalist, showModal,authUser,helperBudget } =
      this.props

    return (
      <React.Fragment>
        <Helmet>
          <title>{i18n.t("Budget List")}</title>
        </Helmet>
        <Budget
          {...this.props}
          authUser={authUser}

          createData={this.createItem}
          voidItem={this.voidItem}
          approveItem={this.approveItem}
          rejectItem={this.rejectItem}
          showModal={showModal}
          helperBudget={helperBudget}
        />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BudgetContainer);
